import { Injectable } from '@angular/core';
import { CommonAccessTokenService, NetworkHelper } from '@wm-libs/core';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WorkerParams, Workers } from '../interfaces//workers.interface';

@Injectable({
  providedIn: 'root',
})
export class WorkersService {
  readonly apiUrl = `${environment.poolApi}/workers`;
  readonly apiAccessTokenUrl = `${environment.poolApi}/access-token/workers`;
  private _initWorkers = new BehaviorSubject<Workers | null>(null);
  readonly initWorkers$ = this._initWorkers.asObservable();

  constructor(private networkHelper: NetworkHelper, private accessTokenService: CommonAccessTokenService) {}

  getWorkers(params?: WorkerParams): Observable<Workers> {
    const finalApiUrl = this.accessTokenService.isAccessTokenPage() ? this.apiAccessTokenUrl : this.apiUrl;

    return this.networkHelper.get<Workers>(`${finalApiUrl}`, params).pipe(take(1));
  }

  setInitWorkers(workers: Workers) {
    this._initWorkers.next(workers);
  }
}
